import { DOMRouteHandler } from './DOMRouteHandler';
import { GiftWrap } from '../modules/GiftWrap';
import { initCartPageActions } from '../modules/cart-page';
import { initInlineCartUpsellModule } from '../modules/inlineCartUpsell';
import { makeModalAccessible } from '../modules/ultimate-upsell-modal';
import { notifyHandledException } from '../utils/errorLogger';
import { when } from '../modules/mutation-observer';

export class TemplateCart extends DOMRouteHandler {
  static init(): void {
    if (document.querySelector('input#gift-wrapping')) {
      GiftWrap.init();
    }

    when('#modal-dialog')
      .insertedInDOM()
      .then(makeModalAccessible)
      .catch(notifyHandledException);

    initInlineCartUpsellModule();
    initCartPageActions();
  }
}
